
try {
(function($) {
    function getParameterByName(name) {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }

    function createCookie(name, value, days) {
        var expires = '',
            date = new Date();
        if (days) {
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    function readCookie(name) {
        var nameEQ = name + "=",
            ca = document.cookie.split(';'),
            c,
            i;
        for (i = 0; i < ca.length; i++) {
            c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function rtrim(str, chars) {
        chars = chars || "\\s";
        return str.replace(new RegExp("[" + chars + "]+$", "g"), "");
    }

    function eraseCookie(name) {
        createCookie(name, "", -1);
    }

    var mcCid = getParameterByName('mc_cid'),
        mcEid = getParameterByName('mc_eid'),
        sitePath = rtrim(window.location.pathname, '/'),
        suffix = 'checkout/thankyou',
        orderId;

    if (mcCid && mcEid) {
        eraseCookie('mc_cid');
        eraseCookie('mc_eid');
        createCookie('mc_cid', mcCid, 30);
        createCookie('mc_eid', mcEid, 30);
    }

    if ($("#gui-form-cart").length) {
        mcCid = readCookie('mc_cid');
        mcEid = readCookie('mc_eid');

        //         var href = $('.gui-button-action').attr('href');
        //         if (href.indexOf("?") > -1) {
        //             href += '&mc_cid=' + mcCid + '&mc_eid=' + mcEid;        
        //         } else {
        //             href += '?mc_cid=' + mcCid + '&mc_eid=' + mcEid;        
        //         }
        //     
        //         href = href.replace('/checkout/?', '/checkout/default/?');
        //         $('.gui-button-action').attr('href', href);
    }

    if (sitePath.indexOf(suffix, sitePath.length - suffix.length) !== -1) {
        orderId = $('.gui-thankyou .gui-block-inner strong').html();
        orderId = orderId.replace(/^.*\s/, '');
        mcCid = readCookie('mc_cid');
        mcEid = readCookie('mc_eid');
        if (orderId && mcCid && mcEid) {
            $('body').append('<img src="' + location.protocol + '//seoshop.taurosmedia.com/seochimp/pixel/?orderId=' + orderId + '&mcCid=' + mcCid + '&mcEid=' + mcEid + '" width="1" height="1" />');
            eraseCookie('mc_cid');
            eraseCookie('mc_eid');
        }
    }
})(jQuery);
} catch(e){_st_catch(e)}
